import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "s20",
  for: "mode_livraison_0"
}
const _hoisted_2 = { class: "s1 mt-1" }
const _hoisted_3 = { class: "s5 text-right secondary-font" }
const _hoisted_4 = {
  class: "s20",
  for: "mode_livraison_1"
}
const _hoisted_5 = { class: "s1 mt-1" }
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 0,
  class: "s11 pl-2 secondary-font"
}
const _hoisted_8 = { class: "secondary-font text-grey-600" }
const _hoisted_9 = {
  key: 1,
  class: "s11 pl-2 secondary-font"
}
const _hoisted_10 = { class: "s5 text-right secondary-font" }

import { ref, watch, PropType } from 'vue';
import { formatAmount } from '@/utils/formatters';

interface StartupInfosCheckout {
    adresses: any[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MarketCheckoutModeLivraisonForm',
  props: {
    modelValue: { type: Number, default: null },
    startupInfos: { type: Object as PropType<StartupInfosCheckout>, default: null },
    adresse: { type: Object, default: null },
},
  emits: ['update:modelValue', 'onEditAdresse'],
  setup(__props, { emit: __emit }) {

// @ts-expect-error raison: lib externe mal typée
const props = __props;
const emit = __emit;
const modeLivraison = ref(-1);

watch(props, () => {
    if (props.modelValue) {
        modeLivraison.value = props.modelValue;
    }
}, { deep: true });

watch(modeLivraison, () => {
    emit('update:modelValue', modeLivraison.value);
}, { deep: true });

function onEditAdresse(adresse?: any) {
    emit('onEditAdresse', adresse);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[16] || (_cache[16] = _createElementVNode("h2", { class: "secondary-font mb-4" }, "Mode de livraison", -1)),
    _cache[17] || (_cache[17] = _createElementVNode("h6", { class: "secondary-font mb-3" }, " Livraison : sam. 14 juin - mar. 17 juin 2026 ", -1)),
    _cache[18] || (_cache[18] = _createElementVNode("h6", { class: "secondary-font mb-4 text-grey-700" }, [
      _createTextVNode(" Abidjan Cocody Faya Nouveau Goudro"),
      _createElementVNode("br"),
      _createTextVNode(" +225 08 07 07 07 07 ")
    ], -1)),
    _createElementVNode("div", {
      class: _normalizeClass(["card-check bg-white-50 widget flex my-2 pt-5 pb-4 px-6", {'active': modeLivraison.value === -1}])
    }, [
      _createElementVNode("label", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            class: "",
            type: "radio",
            name: "super",
            id: "mode_livraison_0",
            value: -1,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modeLivraison).value = $event))
          }, null, 512), [
            [_vModelRadio, modeLivraison.value]
          ])
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("h5", { class: "s11 pl-2 secondary-font" }, [
          _createTextVNode("Retrait en point relais "),
          _createElementVNode("br", { class: "mb-2" }),
          _createElementVNode("span", { class: "secondary-font text-grey-600" }, "Adresse de la collectivité")
        ], -1)),
        _createElementVNode("h4", _hoisted_3, _toDisplayString(_unref(formatAmount)(0)) + " F", 1),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "s3 text-right" }, [
          _createElementVNode("img", {
            src: "/public/icons/icon-livraison-relais.svg",
            class: "size-base",
            alt: ""
          })
        ], -1))
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["card-check bg-white-50 widget flex my-2 pt-5 pb-4 px-6", {'active': modeLivraison.value === 1, 'livraison-item-disabled': !props.adresse}])
    }, [
      _createElementVNode("label", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            class: "",
            type: "radio",
            name: "super",
            id: "mode_livraison_1",
            value: props.adresse?.id,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modeLivraison).value = $event))
          }, null, 8, _hoisted_6), [
            [_vModelRadio, modeLivraison.value]
          ])
        ]),
        (props.adresse)
          ? (_openBlock(), _createElementBlock("h5", _hoisted_7, [
              _createTextVNode(_toDisplayString(props.adresse.libelle) + " ", 1),
              _cache[8] || (_cache[8] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
              _createElementVNode("span", _hoisted_8, [
                _createTextVNode(_toDisplayString(props.adresse.adresse) + " ", 1),
                _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                _createTextVNode(_toDisplayString(props.adresse.telephone), 1)
              ]),
              _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("a", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (onEditAdresse(props.adresse))),
                style: {"cursor":"pointer"}
              }, [...(_cache[7] || (_cache[7] = [
                _createElementVNode("h6", { class: "text-black mt-1" }, "Modifier", -1)
              ]))])
            ]))
          : _createCommentVNode("", true),
        (!props.adresse)
          ? (_openBlock(), _createElementBlock("h5", _hoisted_9, [
              _cache[11] || (_cache[11] = _createTextVNode("Livraison à domicile ", -1)),
              _cache[12] || (_cache[12] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
              _cache[13] || (_cache[13] = _createElementVNode("span", { class: "secondary-font text-grey-600" }, " Aucune adresse définie ", -1)),
              _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("a", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (onEditAdresse())),
                style: {"cursor":"pointer","opacity":"1"}
              }, [...(_cache[10] || (_cache[10] = [
                _createElementVNode("h6", { class: "text-black mt-1" }, "Modifier", -1)
              ]))])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("h4", _hoisted_10, _toDisplayString(props.adresse ? _unref(formatAmount)(2000) : '-') + " F", 1),
        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "s3 text-right" }, [
          _createElementVNode("img", {
            src: "/public/icons/icon-livraison-domicile.svg",
            class: "size-base",
            alt: ""
          })
        ], -1))
      ])
    ], 2)
  ], 64))
}
}

})